module.exports = __webpack_public_path__ + "static/assets/d859e71f6a54417d6f5d7ec226db6f43.png";